/**
 * need
 * GET_ONE
 * DELETE
 * UPDATE
 */
import { CONFIG_API } from "@/plugins/axios";
import { parseBRPattern } from "@/models/Utils.js";
import moment from "moment";
export default class ConstantMeasure {

    multiplier = 1;

    constructor(item) {
        if (item) {
            this.id = item.id;
            this.name = item.name;
            this.description = item.description;
            this.eu = item.eu;
            this.multiplier = item.multiplier ? parseFloat(item.multiplier) : 1;
            this.value = item.value;
            this.decimalPlace = item.decimalPlace ? item.decimalPlace : 2;
            this.plant = item.plant;
            this.equipment = item.equipment;
        }
    }

    setAttributes(constantRef) {
        const { name, multiplier, description, eu, decimalPlace } = constantRef;
        if (multiplier) this.multiplier *= parseFloat(multiplier);
        if (description) this.description = description;
        if (eu) this.eu = eu;
        if (typeof decimalPlace === "number" && decimalPlace >= 0) this.decimalPlace = decimalPlace;
        if (name) {
            this.nameRef = this.name;
            this.name = name;
        }
        return this;
    }

    checkVal() {
        if (this.float() !== 0 && this.value !== false) {
            if (!this.value) return false;
            if (this.value === "undefined") return false;
            if (this.value === "null") return false;
        }
        return true;
    }
    toFloat(val) {
        return parseFloat(String(val).replace(",", "."));
    }
    round(decimal_places) {
        if (!decimal_places && decimal_places != 0) decimal_places = this.decimalPlace;
        if (!decimal_places && decimal_places != 0) decimal_places = 2;
        return parseFloat(parseFloat(String(this.value).replace(",", ".")).toFixed(decimal_places));
    }
    number() {
        return Number(this.value);
    }
    float() {
        return parseFloat(String(this.value).replace(",", "."));
    }
    int() {
        return parseInt(String(this.value).replace(",", "."));
    }
    str() {
        return String(this.value);
    }
    getEu() {
        return this.eu ? this.eu : "";
    }

    getValue(decimalPlaces, BRPattern = true) {
        if (!this.checkVal()) return "-";

        decimalPlaces = Number(decimalPlaces);
        if (isNaN(decimalPlaces)) {
            decimalPlaces = this.decimalPlace;
        }

        let value = this.value;
        if (this.multiplier !== 1) {
            value = this.number() * this.multiplier;
        }

        let strValue = parseFloat(String(value).replace(",", ".")).toFixed(decimalPlaces);

        return BRPattern ? parseBRPattern(strValue) : strValue;
    }

    label() {
        if (!this.eu) return this.description;
        return `${this.description} (${this.eu})`;
    }

    dataset(type, strStartDate, strEndDate, interval = 1) {
        let currDate = moment(strStartDate);
        let endDate = moment(strEndDate);
        let dataset = [];
        let i = 0;
        while (currDate.isBefore(endDate)) {
            if (i > 100000) break;
            i++;
            let element = { x: currDate.format("YYYY-MM-DDTHH:mm:ss"), y: this.round(this.decimalPlace) };
            currDate = currDate.clone().add(interval, type);
            dataset.push(element);
        }
        return dataset;
    }
}

export async function getConstantMeasures(params) {
    try {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + localStorage.getItem("config_token")
        };
        const config = { headers, params };
        let res = await CONFIG_API.get("constant-measures/", config);
        if (res && res.status == 200) {
            if ("page" in res.data) {
                res.data.results = res.data.results.map(e => new ConstantMeasure(e));
                return res.data;
            }
            let data = res.data.map(e => new ConstantMeasure(e));
            return data;
        }
    } catch (e) {
        console.error(e);
        return [];
    }
}
